import type { FC } from "react";
import { Route, Redirect, type RouteProps } from "react-router-dom";
import { useUrlWithSearchParams } from "../../helpers/routeHelpers";
import { useMctFlags } from "../../helpers/flag-hooks/useMctFlags";

export const ProviderNetworkRoute: FC<RouteProps> = ({ children, ...rest }) => {
  const { tmpFeEnableProviderNetwork } = useMctFlags();

  const redirect = useUrlWithSearchParams("/");

  if (tmpFeEnableProviderNetwork) {
    return <Route {...rest}>{children}</Route>;
  }
  // Provider Network not enabled, go to landing page.
  return <Redirect to={redirect} />;
};
